import React from 'react'
import {
    Flex,
    Text,
    useMultiStyleConfig,
    Button,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {AdviceIcon} from '../../../components/icons'

export default function BannerLiveChat() {
    const styles = useMultiStyleConfig('Faq', {})
    const {bannerLiveChatStyles} = styles || null

    const handleSnapCall = () => {
        const snapEngageObject = window?.SnapEngage || {}
        if (Object.keys(snapEngageObject).length > 0) {
            if (snapEngageObject?.isProactiveChatAllowed) {
                window.SnapEngage.openProactiveChat(true, true)
            }
        }
    }

    const supportUrl = `https://support.delonghi.com/en`

    return (
        // This class toggle-live-banner is used by gtm to toggle the vissibility of the banner. The display none is set inside a style in the _app -> helmet
        <Flex {...bannerLiveChatStyles?.bannerContainer} className="toggle-live-banner">
            <Flex {...bannerLiveChatStyles?.bannerInnerContainer}>
                <Flex {...bannerLiveChatStyles?.iconContainer}>
                    <AdviceIcon {...bannerLiveChatStyles?.adviceIcon} />
                </Flex>
                <Text {...bannerLiveChatStyles?.simpleText}>
                    <FormattedMessage
                        id="faq_page.live_chat_banner.message_simple"
                        defaultMessage="To find the solution you were looking for, consult our"
                    />{' '}
                    <Button
                        className="trigger-virtual-assistant"
                        variant="text-button"
                        {...bannerLiveChatStyles?.linkText}
                        onClick={handleSnapCall}
                    >
                        <FormattedMessage
                            id="faq_page.live_chat_banner.assistant_link"
                            defaultMessage="Virtual Assistant"
                        />
                    </Button>{' '}
                    <FormattedMessage
                        id="faq_page.live_chat_banner.usage"
                        defaultMessage="with its usage "
                    />{' '}
                    <Button
                        as="a"
                        variant="text-button"
                        target="_blank"
                        {...bannerLiveChatStyles?.linkText}
                        href={supportUrl}
                    >
                        <FormattedMessage
                            id="faq_page.live_chat_banner.guide_link"
                            defaultMessage="guides "
                        />
                    </Button>{' '}
                    <FormattedMessage
                        id="faq_page.live_chat_banner.solutions"
                        defaultMessage="and solutions to the most recurring problems"
                    />{' '}
                </Text>
            </Flex>
        </Flex>
    )
}
